import { Column } from '../../../grids';
import { ReactElement } from 'react';
import { formatDate } from '../../../../../../ui/src';
import React from 'react';
import { formatCurrencyConditional } from '../totalItems/constants/constants';

interface IDrawAutomaticBorrowerColumnProps {
    drawId: number;
    drawNumber: number;
    drawFinalized: boolean;
    fundedOn: Date;
}

export const DrawAutomaticBorrowerColumn = ({
    drawId,
    drawNumber,
    fundedOn,
    drawFinalized,
}: IDrawAutomaticBorrowerColumnProps): ReactElement[] => {
    const columnHeaderFunded = () => {
        return (
            <div style={{ width: 90, textAlign: 'center' }}>
                <p>
                    {`DRAW #${drawNumber + 1}`}
                    <br />
                    {`Funded On ${formatDate(fundedOn)}`}
                </p>
            </div>
        );
    };

    const columnHeaderInspecting = () => {
        return (
            <div style={{ width: 90, textAlign: 'center' }}>
                <p>
                    {`DRAW #${drawNumber + 1}`}
                    <br />
                    (pending)
                </p>
            </div>
        );
    };

    if (drawFinalized) {
        return [
            <Column
                name={`Column${drawId}-${drawNumber}`}
                key={`Column${drawId}-${drawNumber}`}
                dataField={`drawItems-funded-${drawId}-${drawNumber}`}
                allowEditing={false}
                cellRender={(cellData) => {
                    const dataItem = cellData.data?.drawItems?.find((item) => item.drawNumber == drawNumber);
                    return formatCurrencyConditional(dataItem?.funded);
                }}
                headerCellRender={columnHeaderFunded}
                caption={`DRAW #${drawNumber + 1}`}
                format={'currency'}
                alignment={'right'}
                allowResizing={false}
                minWidth={100}
                width={100}
            />,
        ];
    } else {
        return [
            <Column
                name={`Column${drawId}-${drawNumber}`}
                key={`Column${drawId}-${drawNumber}`}
                dataField={`drawItems-inspection-${drawId}-${drawNumber}`}
                cellRender={(cellData) => {
                    const dataItem = cellData.data?.drawItems?.find((item) => item.drawNumber == drawNumber);
                    return formatCurrencyConditional(dataItem?.inspection);
                }}
                allowEditing={false}
                headerCellRender={columnHeaderInspecting}
                caption={`DRAW #${drawNumber + 1}`}
                format={'currency'}
                alignment={'right'}
                allowResizing={false}
                minWidth={100}
                width={100}
            />,
        ];
    }
};
